import React, { useRef, useState } from "react";
import styles from "./FileInput.module.scss";
import { Controller } from "react-hook-form";
import { TextField, InputAdornment } from "@mui/material";
import { combineClasses } from "@/lib/utils";
import withLabelAndError from "../withLabelAndError";
import {
  InputControlProps,
  WithLabelAndErrorComponent,
} from "@/types/formControls";

const FileInput: React.FC<InputControlProps> = (props) => {
  const {
    control,
    register,
    validations,
    name,
    error,
    placeholder = "No file chosen",
    className,
    ...rest
  } = props;

  const fileRef = useRef<HTMLInputElement | null>(null);
  const [fileName, setFileName] = useState("");

  const openFilePicker = () => {
    fileRef.current?.click();
  };

  const renderInput = (field: any = {}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      const file = e.target.files?.[0];

      setFileName(file?.name || "");
      field?.onChange?.(file);
    };

    return (
      <>
        <TextField
          value={fileName}
          placeholder={placeholder}
          variant="outlined"
          onClick={openFilePicker}
          className={combineClasses(
            styles.inputRoot,
            error && styles.error,
            className,
          )}
          slotProps={{
            input: {
              readOnly: true,
              startAdornment: (
                <InputAdornment position="start">
                  <button
                    type="button"
                    className={styles.fileButton}
                    onClick={openFilePicker}
                  >
                    Choose File
                  </button>
                </InputAdornment>
              ),
            },
            htmlInput: {
              className: combineClasses(styles.inputField),
            },
          }}
        />

        <input
          type="file"
          hidden
          ref={(el) => {
            fileRef.current = el;
            field?.ref?.(el);
          }}
          onChange={handleChange}
          {...rest}
        />
      </>
    );
  };

  if (control) {
    return (
      <Controller
        control={control}
        name={name}
        rules={validations}
        render={({ field }) => renderInput(field)}
      />
    );
  }

  const field = register?.(name, validations);
  return renderInput(field);
};

const FileInputWithLabelAndError = withLabelAndError(
  FileInput as WithLabelAndErrorComponent,
);

export default FileInputWithLabelAndError;
export { FileInput };
